// AUTO-GENERATED FILE. DO NOT EDIT.
// This file was generated by tools/write-version.js
// Commit: 57ce4f1, Branch: HEAD, Build: 503

export const APP_VERSION = "1.7.24";
export const PREVIOUS_COMMIT_HASH = "57ce4f1";
